import {
  clubRatingColumns,
  factorStatsColumns,
  upDownColumns,
} from '@/modules/league/new-components/constants';
import { StatsTable } from '@/modules/league/new-components/groups-components/GroupsComponent/StatsTable';
import { GroupPlayer } from '@/modules/league/new-components/types';

// One of these tables shows on group card for each player row in group when match is started
export const getStatsTableForGroup = (player: GroupPlayer, rankingType: string) => {
  return (
    <div className='flex w-full flex-col border bg-border-500/30'>
      {rankingType === 'UpDown' ? (
        <StatsTable player={player} columns={upDownColumns} />
      ) : rankingType === 'Factors' ? (
        <StatsTable player={player} columns={factorStatsColumns} />
      ) : rankingType === 'Custom' ||
        rankingType === 'ClubRating' ||
        rankingType === 'DUPRRating' ? (
        <StatsTable player={player} columns={clubRatingColumns} />
      ) : null}
    </div>
  );
};
